'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.navigations = void 0;
var adapter_1 = require("../adapter");
var Navigations = /** @class */ (function () {
    function Navigations() {
    }
    /**
     * Gets the navigations items from the Navigation Manager depending
     * on device type and language.
     */
    Navigations.prototype.getNavigations = function (isDesktop, isMobile, langs) {
        var params = { isDesktop: isDesktop, isMobile: isMobile, langs: langs };
        return adapter_1.adapter.navigations.getNavigations(params);
    };
    return Navigations;
}());
exports.navigations = new Navigations();
